import { useEffect, useState } from "react";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import { validateMin } from "../../../../utils/validateMin";
import CustomFormatDatePicker from "../../../../components/common/CustomFormatDatePicker";
import useGeneral from "../../../../components/hooks/useGeneral";
import { useTheme } from "../../../../components/hooks/useTheme";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import useDelete from "../../../../components/hooks/useDelete";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const EditDiscounts = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const navigate = useNavigate();
  const idNumber = useLocation();
  const { dateFormat }: any = useGeneral();
  const { themeStyles } = useTheme();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const [branch, setBranch] = useState([]);
  const [name, setName] = useState<string>("");
  const [branchId, setBranchId] = useState<string>("");
  const [discounttype, setDiscounttype] = useState<string>("Percentage");
  const [discountAmount, setDiscountAmount] = useState<string>("");
  const [couponCode, setCouponCode] = useState<string>("");
  const [isActive, setIsActive] = useState<string>("No");
  const [discountScope, setDiscountScope] = useState<string>("All");
  const [visibleForDirectbooker, setVisibleForDirectbooker] = useState<string>("No");
  const [order, setOrder] = useState<string>("");
  const [vehicleClassIds, setVehicleClassIds] = useState<string>("");
  const [allowedLocationIds, setAllowedLocationIds] = useState<string>("");
  const [includedAdditionalChargeIds, setIncludedAdditionalChargeIds] =
    useState<string>("");
  const [availableFrom, setAvailableFrom] = useState<string>("");
  const [availableUntil, setAvailableUntil] = useState<string>("");
  const [isReuse, setIsReuse] = useState<string>("No");
  const [daysToApplyThisDiscount, setDaysToApplyThisDiscount] = useState<string>("");
  const [itemsselected, setItemsselected] = useState<string>("");
  const [freeAdditionalCharges, setFreeAdditionalCharges] = useState<string>("")
  const [topDaysToApplyThisDiscount, setTopDaysToApplyThisDiscount] = useState<string>("")
  const [disabled, setDisabled] = useState<boolean>(true);
  const [
    isSkipAutomaticApplicationBasedonDays,
    setIsSkipAutomaticApplicationBasedonDays,
  ] = useState<string>("No");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [isClone, setIsClone] = useState<boolean>(false);

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setBranch(() =>
          response?.data?.map((item: any) => {
            return { value: item.id, label: item?.branchName };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPleaseWaitPopup(true);
    axios
      .get(`${baseURL}discount/${idNumber?.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setName(response?.data?.name);
        setBranchId(response?.data?.branchId);
        setDiscounttype(response?.data?.discounttype);
        setDiscountAmount(response?.data?.discountAmount);
        setCouponCode(response?.data?.couponCode);
        setIsActive(response?.data?.isActive ? "Yes" : "No");
        setDiscountScope(response?.data?.discountScope);
        setVehicleClassIds(response?.data?.vehicleClassIds);
        setOrder(response?.data?.order);
        setVisibleForDirectbooker(response?.data?.visibleForDirectbooker ? "Yes" : "No");
        setAllowedLocationIds(response?.data?.allowedLocationIds);
        setIncludedAdditionalChargeIds(
          response?.data?.includedAdditionalChargeIds
        );
        setAvailableFrom(response?.data?.availableFrom.split("T")[0]);
        setAvailableUntil(response?.data?.availableUntil.split("T")[0]);
        setIsReuse(response?.data?.isReuse ? "Yes" : "No");
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setPleaseWaitPopup(true);
    e.preventDefault();
    if (isClone) {
      axios
        .post(
          `${baseURL}discount?userId=${auth?.id}`,
          JSON.stringify({
            name,
            branchId,
            discounttype,
            discountAmount,
            couponCode,
            isActive: isActive === "Yes",
            discountScope,
            visibleForDirectbooker: visibleForDirectbooker === "Yes",
            order,
            vehicleClassIds,
            allowedLocationIds,
            includedAdditionalChargeIds,
            availableFrom: availableFrom + "T00:00:00",
            availableUntil: availableUntil + "T00:00:00",
            isReuse: isReuse === "Yes",
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          navigate(-1);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      axios
        .put(
          `${baseURL}discount?userId=${auth?.id}`,
          JSON.stringify({
            id: idNumber?.state,
            name,
            branchId,
            discounttype,
            discountAmount,
            couponCode,
            isActive: isActive === "Yes",
            discountScope,
            visibleForDirectbooker: visibleForDirectbooker === "Yes",
            order,
            vehicleClassIds,
            allowedLocationIds,
            includedAdditionalChargeIds,
            availableFrom: availableFrom + "T00:00:00",
            availableUntil: availableUntil + "T00:00:00",
            isReuse: isReuse === "Yes",
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          navigate(-1);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    }
  };

  const deleteDiscount = () => {
    setDeleteData({
      id: idNumber,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Discount?`,
      isDelete: (callback: any) => {
        fetch(`${baseURL}discount?id=${idNumber?.state}&userId=${auth?.id}`, {
          method: 'DELETE',
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setPleaseWaitPopup(false);
            navigate(-1);
            callback();
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            callback();
            handleTenantError(error);
          });
      }
    });

    setDeletePopup(true);
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Discount</h2>
                </div>
                <div className="flex items-center gap-1.5">
                  {
                    !isClone && (
                      <button className={`px-[12px] py-[10px] ${colorConfigs.btn.main.tailwind} shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                        onClick={() => {
                          setIsClone(true)
                          setDisabled(false);
                        }
                        }
                      >
                        <span className="text-xs font-medium">Clone Discount</span>
                      </button>
                    )
                  }
                  {
                    disabled && (
                      <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                        onClick={() => setDisabled(false)}
                      >
                        <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                          edit
                        </span>
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                      </button>
                    )
                  }
                </div>
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <h5 className="mt-1 pb-0 flex justify-start items-center text-gray-500">
                      Discount Overview
                    </h5>
                    <hr className="mb-4" />
                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                          <select
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={branchId}
                            disabled={disabled}
                            onChange={(e) => setBranchId(e.target.value)}
                          >
                            {branch?.map((role: any, index: number) => (
                              <option key={index} value={role.value}>
                                {role.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Discount Type</label>
                          <select
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={discounttype}
                            disabled={disabled}
                            onChange={(e) => setDiscounttype(e.target.value)}
                          >
                            <option value="Percentage">Percentage</option>
                            <option value="Amount">Amount</option>
                          </select>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Coupon Code</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={couponCode}
                            disabled={disabled}
                            onChange={(e) => setCouponCode(e.target.value)}
                            required
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Discount Scope</label>
                          <select
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={discountScope}
                            disabled={disabled}
                            onChange={(e) => setDiscountScope(e.target.value)}
                          >
                            <option value="All">All</option>
                          </select>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Order</label>
                          <input
                            type="number"
                            min={0}
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={order}
                            disabled={disabled}
                            onChange={(e) => setOrder(e.target.value)}
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={name}
                            disabled={disabled}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Discount</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={discountAmount}
                            disabled={disabled}
                            onChange={(e) => setDiscountAmount(e.target.value)}
                            required
                          />
                        </div>

                        <div className="mt-4">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                          <RadioGroup
                            row
                            value={isActive}
                            onChange={(e) => setIsActive(e.target.value)}
                          >
                            <FormControlLabel
                              value="Yes" control=
                              {<Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="Yes"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                            <FormControlLabel value="No" control={
                              <Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="No"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                          </RadioGroup>
                        </div>

                        <div className="mt-4">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Visible For Direct booker?</label>
                          <RadioGroup
                            row
                            value={visibleForDirectbooker}
                            onChange={(e) => setVisibleForDirectbooker(e.target.value)}
                          >
                            <FormControlLabel
                              value="Yes" control=
                              {<Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="Yes"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                            <FormControlLabel value="No" control={
                              <Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="No"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </div>

                    <h5 className="mt-6 pb-0 flex justify-start items-center text-gray-500">
                      Restrictions
                    </h5>
                    <hr className="mb-4" />

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Vehicle Classes</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={vehicleClassIds}
                            disabled={disabled}
                            onChange={(e) => setVehicleClassIds(e.target.value)}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Included Additional Charges</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={includedAdditionalChargeIds}
                            disabled={disabled}
                            onChange={(e) => setIncludedAdditionalChargeIds(e.target.value)}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>When Selected, These Items can't be selected</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={itemsselected}
                            disabled={disabled}
                            onChange={(e) => setItemsselected(e.target.value)}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Available From</label>
                          <CustomFormatDatePicker
                            value={availableFrom}
                            disabled={disabled}
                            onChange={setAvailableFrom}
                            dateFormat={dateFormat}
                            required={true}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Days to apply this discount</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={daysToApplyThisDiscount}
                            disabled={disabled}
                            onChange={(e) => setDaysToApplyThisDiscount(e.target.value)}
                          />
                        </div>

                        <div className="mt-4">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Skip Automatic Application Based on Days</label>
                          <RadioGroup
                            row
                            value={isSkipAutomaticApplicationBasedonDays}
                            onChange={(e) => setIsSkipAutomaticApplicationBasedonDays(e.target.value)}
                          >
                            <FormControlLabel
                              value="Yes" control=
                              {<Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="Yes"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                            <FormControlLabel value="No" control={
                              <Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="No"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Locations</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={allowedLocationIds}
                            disabled={disabled}
                            onChange={(e) => setAllowedLocationIds(e.target.value)}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Free Additional Charges</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={freeAdditionalCharges}
                            disabled={disabled}
                            onChange={(e) => setFreeAdditionalCharges(e.target.value)}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium invisible ${themeStyles.form.tailwindLabelTextColor}`}>Free Additional Charges</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md invisible ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Available Until</label>
                          <CustomFormatDatePicker
                            value={availableUntil}
                            disabled={disabled}
                            onChange={setAvailableUntil}
                            dateFormat={dateFormat}
                            required={true}
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Top Days to apply this discount</label>
                          <input
                            type="number"
                            min={0}
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={topDaysToApplyThisDiscount}
                            disabled={disabled}
                            onChange={(e) => setTopDaysToApplyThisDiscount(validateMin(e.target.value, 0).toString())}
                          />
                        </div>

                        <div className="mt-4">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Disable Re-use</label>
                          <RadioGroup
                            row
                            value={isReuse}
                            onChange={(e) => setIsReuse(e.target.value)}
                          >
                            <FormControlLabel
                              value="Yes" control=
                              {<Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="Yes"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                            <FormControlLabel value="No" control={
                              <Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="No"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-4 mt-6">
                      {
                        !disabled && (
                          <Button variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg
                            }}
                            type="submit">
                            Save
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}>
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.delete.bg
                        }}
                        onClick={deleteDiscount}>
                        Delete
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
